<template>
  <div class="inline-sequence">
    <!--
    <span :style="{fontFamily: effortStatusText.fontFamily, color: effortStatusText.color}">
      {{effortStatusText.text}} XX
    </span>
    -->

    <table class="table card-table table-vcenter text-nowrap">
      <thead>
        <tr>
          <th class="w-1">Day</th>
          <th>Type</th>
          <th>Title</th>
          <th>Duration</th>
        </tr>
      </thead>
      <tr
        v-for="(item, idx) in sequenceEffort.sessionTemplateListType2"
        :key="'type2-item-'+idx"
        class="item">
        <td><span class="text-muted">{{idx}}</span></td>
        <td>
          <el-tag size="mini">{{item.type}}</el-tag>
        </td>
        <td><strong>{{item.description}}</strong></td>
        <td>{{item.sessionLength}}</td>
        <td>
          <div v-if="item.type === 'SESSION'">
            <ul
              v-if="item.taskSequence && item.taskSequence.length > 0"
              style="margin: 0; padding: 0 0 0 1.1em">
              <li v-for="(task, idx_task) in item.taskSequence" :key="'task-'+idx_task+'-'+idx">
                {{task.description}} ({{task.duration}} min)
              </li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
    <template v-if="showEditButton">
      <font-awesome-icon icon="wrench" @click="onEditCommitment" style="cursor: pointer; margin-right: 0.4em"/>
    </template>
  </div>
</template>

<script>

/* TODO: FINISH AS SOON AS INCLUDED IN KANBAN */

import CommitmentMixin from '@/components/Inline/CommitmentMixin'

export default {
  mixins: [CommitmentMixin],
  props: {
    sequenceEffort: {
      type: Object,
      required: true
    },
    showEditButton: {
      default: false
    }
  },
  created() {
    if ( this.sequenceEffort.type !== 'SEQUENCE_TYPE2' ) {
      throw new Error ('Invalid effort type', this.sequenceEffort.type);
    }
  },
  computed: {
    effortTextAsProp() {
      console.log("effortTextAsProp");
      return this.commitmentText( this.sequenceEffort );
    },

    effortStatusText() {
      let { color, text } = this.commitmentStatusColorAndText( this.sequenceEffort  );
      return {
        text: text,
        fontFamily: "Arial", // TODO
        color: color
      };
    },
  },
  methods: {
    onEditCommitment() {
      this.$root.showUpdateModal('effort', {
        goalId: this.sequenceEffort.goalId,
        commitmentId: this.sequenceEffort.commitmentId
      });
    },
  }
}
</script>

<style>
.inline-sequence .table td {
  padding: 4px 0;
}
</style>
